import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getTableRowQaProps,
  TableCellBase,
  TableCellFreeSpaceFiller,
  TableCellText,
} from '../../../../../Table'
import { APPLICANT_COMPARISON_ROW_LABEL_KEY } from '../RentalPortalApplicantComparison.constants'

import {
  getIsApplicantComparisonLabelColumn,
  renderApplicantComparisonCell,
} from './RentalPortalApplicantComparisonRow.utils'

import * as styles from './RentalPortalApplicantComparisonRow.module.css'

function RentalPortalApplicantComparisonRow({
  applicantByColumn,
  columns,
  emptyColumnSize,
  hasSelection,
  isResizing,
  item,
  resizingColumn,
  showCellBorder,
  onClickProfile,
  onClickSelect,
}) {
  const { t } = useTranslation()

  const labelKey = APPLICANT_COMPARISON_ROW_LABEL_KEY[item.id]

  return (
    <div
      {...getTableRowQaProps()}
      className={styles.RentalPortalApplicantComparisonRow}
    >
      {columns.map(column =>
        getIsApplicantComparisonLabelColumn(column) ? (
          <TableCellBase
            className={styles.labelCell}
            key={column.name}
            showCellBorder={showCellBorder}
            width={column.width}
          >
            {labelKey ? (
              <TableCellText
                isSecondary
                showTooltip={false}
                value={t(labelKey)}
              />
            ) : null}
          </TableCellBase>
        ) : (
          <Fragment key={column.name}>
            {renderApplicantComparisonCell({
              applicant: applicantByColumn.get(column.name),
              classes: styles,
              hasSelection,
              isActive: column.name === resizingColumn,
              isResizing,
              name: item.id,
              showCellBorder,
              t,
              width: column.width,
              onClickProfile,
              onClickSelect,
            })}
          </Fragment>
        )
      )}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default RentalPortalApplicantComparisonRow
